<template>
  <div class="lobby-container">
    <div class="room-card">
      <h3>Room: {{ roomId }}</h3>

      <!-- Player List -->
      <div class="players">
        <ul>
          <li v-for="player in players" :key="player">{{ player }}</li>
        </ul>
      </div>

      <!-- Buttons -->
      <div v-if="players[0] === userName" class="input-group">
        <label for="maxPoints">Max Points:</label>
        <input v-model.number="maxPoints" type="number" min="1" max="50" />
      </div>

      <button
        v-if="players[0] === userName"
        :disabled="!maxPoints || maxPoints < 1"
        @click="startGame(maxPoints)"
      >
        Start Game
      </button>

      <button class="leave" @click="leaveRoom">Leave Room</button>
    </div>
  </div>
</template>

<script>
import storage from '@/utility/storage.js'
import { SocketManager } from '@/utility/SocketManager.js'
export default {
  inject: ['socket'],
  data() {
    return {
      socketManager: null,
      userName: storage.get('userName'), // Username from query params
      roomId: this.$route.params.roomId, // Room name from route params
      players: [], // List of players
      playerId: storage.get('playerId'),
      maxPoints: 10,
    }
  },
  methods: {
    leaveRoom() {
      console.log('Leaving room...')
      this.socketManager.emitSocketEvent('leaveRoom', {
        roomId: this.roomId,
        playerId: this.playerId,
      })

      this.$router.push('/lobby')
      storage.remove('playerId')
    },
    startGame(maxPoints) {
      if (!maxPoints) {
        console.error('Please enter the max points')
        return
      }

      console.log('Starting game with roomname ...', this.roomId)
      this.socketManager.emitSocketEvent('startGame', {
        roomId: this.roomId,
        maxPoints,
      }) // Emit the startGame event
    },
  },
  mounted() {
    this.socketManager = new SocketManager(this.socket)

    this.socketManager.emitSocketEvent(
      'connected',
      {
        playerId: this.playerId,
        roomId: this.roomId,
      },
      (res) => {
        if (!res) {
          console.error('Failed to connect to the game!')
          return
        }
      }
    )

    this.socketManager.onSocketEvent('connect', () => {
      console.log('Connected to the server!')
      this.socketManager.emitSocketEvent(
        'connected',
        { playerId: this.playerId, roomId: this.roomId },
        (res) => {
          if (!res) {
            console.error('Failed to connect to the game!')
            return
          }
        }
      )
    })

    // Register the listener for the 'updatePlayers' event
    this.socketManager.onSocketEvent('updateRoomPlayers', (players) => {
      this.players = players // Update the players array when the event is emitted
    })

    // Register the listener for the 'gameStarted' event
    this.socketManager.onSocketEvent('gameStarted', (roomId, maxPoints) => {
      console.log('Game started!')
      storage.set('gameId', roomId)
      this.$router.push({
        path: `/game/${roomId}`,
        query: {
          maxPoints: maxPoints,
        },
      })
    })
  },
  beforeUnmount() {
    // Remove the listener to prevent memory leaks
    this.socketManager.offSocketEvent('connect')
    this.socketManager.offSocketEvent('updateRoomPlayers')
    this.socketManager.offSocketEvent('gameStarted')
  },
}
</script>

<style scoped>
/* Card-like container */
.room-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 80%;
}

/* Title */
.room-card h3 {
  color: #333;
  margin: 0;
}

/* Players section */
.players h2,
.players h3,
.players h4 {
  margin: 0;
  color: #444;
}

.players ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.players li {
  border-radius: 5px;
  font-size: 1rem;
}

.input-group {
  gap: 0.2rem;
  font-size: 0.7rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
}

/* Buttons */
.room-card button {
  width: 100%;
  padding: 12px;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  background-color: darkgreen; /* Red - Start Game */
  color: white;
  cursor: pointer;
  margin-top: 10px;
  transition: 0.3s ease-in-out;
  max-width: 300px;
}

.room-card button.leave {
  background-color: red; /* Blue - Leave Room */
}

/* Hover Effects */
.room-card button:hover {
  opacity: 0.8;
}

/* Responsive Design */
@media (min-width: 600px) {
  .room-card {
    padding: 20px;
    width: 50%;
  }
}
</style>
